module.exports = __webpack_public_path__ + "static/media/level_19-20.7e504649.jpg";